/**
 * 2007-2019 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2019 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import 'velocity-animate';

import Swiper from './lib/swiper.min';
import PhotoSwipe from './lib/photoswipe.min';
import PhotoSwipeUI_Default from './lib/photoswipe-ui-default.min';

import ProductMinitature from './components/product-miniature';

$(document).ready(() => {
  prestashop.on('clickQuickView', function (elm) {
    let data = {
      'action': 'quickview',
      'id_product': elm.dataset.idProduct,
      'id_product_attribute': elm.dataset.idProductAttribute,
    };
    $.post(prestashop.urls.pages.product, data, null, 'json').then(function (resp) {
      $('body').append(resp.quickview_html);
      let productModal = $(`#quickview-modal-${resp.product.id}-${resp.product.id_product_attribute}`);
      productModal.modal('show');
      productConfig(productModal);
      productModal.on('shown.bs.modal', function() {
        if ($('#thumbs_list_frame .slide').length)
          var productslider_swiper = new Swiper('#thumbs_list_frame .swiper-container', {
            speed: 1000,
            loop: false,
            navigation: {
              nextEl: '#product-next',
              prevEl: '#product-prev',
            },
            initialSlide: $('#thumbs_list_frame .slide.active').index()
          });
      });
      productModal.on('hidden.bs.modal', function () {
        productModal.remove();
      });
      prestashop.on('updatedProduct', function (event, yo=productModal) {
        productConfig(yo);
      });
    }).fail((resp) => {
      prestashop.emit('handleError', {eventType: 'clickQuickView', resp: resp});
    });
  });

  var productConfig = (qv) => {
    let quantityInput = qv.find('#quantity_wanted');
    quantityInput.TouchSpin({
      /*verticalbuttons: true,
      verticalupclass: 'material-icons touchspin-up',
      verticaldownclass: 'material-icons touchspin-down',
      buttondown_class: 'btn btn-touchspin js-touchspin',
      buttonup_class: 'btn btn-touchspin js-touchspin',*/
      min: 1,
      max: 1000000
    });
    var quantity = quantityInput.val();
    $(document).on('keyup change', quantityInput, function(event) {
      const newQuantity = $('#quantity_wanted').val();
      if (newQuantity !== quantity) {
        quantity = newQuantity;
        $('.product-quantity .attribute_value').html(quantity);
      }
      event.preventDefault();

      return false;
    });

    // photoswipe quickview
    $('.images-container .product-images').each( function() {
      var $pic     = $(this),
        getItems = function() {
          var items = [];
          $pic.find('.thumb').each(function() {
            var $href   = $(this).data('image-large-src'),
              $size   = $(this).data('size').split('x'),
              $width  = $size[0],
              $height = $size[1];

            var item = {
              src : $href,
              w   : $width,
              h   : $height
            }

            items.push(item);
          });
          return items;
        }

      var items = getItems();

      var $pswp = $('.pswp')[0];
      $pic.on('click', '.thumb-container', function(event) {
        event.preventDefault();
         
        var $index = $(this).index();
        var options = {
            index: $index,
            bgOpacity: 0.7,
            showHideOpacity: true
        }
         
        // Initialize PhotoSwipe
        var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
        lightBox.init();
      });
    });
  };
  var move = (direction) => {
    const THUMB_MARGIN = 20;
    var $thumbnails = $('.js-qv-product-images');
    var thumbHeight = $('.js-qv-product-images li img').height() + THUMB_MARGIN;
    var currentPosition = $thumbnails.position().top;
    $thumbnails.velocity({
      translateY: (direction === 'up') ? currentPosition + thumbHeight : currentPosition - thumbHeight
    }, function () {
      if ($thumbnails.position().top >= 0) {
        $('.arrow-up').css('opacity', '.2');
      } else if ($thumbnails.position().top + $thumbnails.height() <= $('.js-qv-mask').height()) {
        $('.arrow-down').css('opacity', '.2');
      }
    });
  };
  $('body').on('click', '#search_filter_toggler', function () {
    $('#search_filters_wrapper').removeClass('hidden-sm-down');
    $('#content-wrapper').addClass('hidden-sm-down');
    $('#footer').addClass('hidden-sm-down');
  });
  $('#search_filter_controls .clear').on('click', function () {
    $('#search_filters_wrapper').addClass('hidden-sm-down');
    $('#content-wrapper').removeClass('hidden-sm-down');
    $('#footer').removeClass('hidden-sm-down');
  });
  $('#search_filter_controls .ok').on('click', function () {
    $('#search_filters_wrapper').addClass('hidden-sm-down');
    $('#content-wrapper').removeClass('hidden-sm-down');
    $('#footer').removeClass('hidden-sm-down');
  });

  const parseSearchUrl = function (event) {
    if (event.target.dataset.searchUrl !== undefined) {
      return event.target.dataset.searchUrl;
    }

    if ($(event.target).parent()[0].dataset.searchUrl === undefined) {
      throw new Error('Can not parse search URL');
    }

    return $(event.target).parent()[0].dataset.searchUrl;
  };

  $('body').on('change', '#search_filters input[data-search-url]', function (event) {
    prestashop.emit('updateFacets', parseSearchUrl(event));
  });

  $('body').on('click', '.js-search-filters-clear-all', function (event) {
    prestashop.emit('updateFacets', parseSearchUrl(event));
  });

  $('body').on('click', '.js-search-link', function (event) {
    event.preventDefault();
    prestashop.emit('updateFacets', $(event.target).closest('a').get(0).href);
  });

  $('body').on('change', '#search_filters select', function (event) {
    const form = $(event.target).closest('form');
    prestashop.emit('updateFacets', '?' + form.serialize());
  });

  prestashop.on('updateProductList', (data) => {
    updateProductListDOM(data);
  });

  bindGrid();
});

function updateProductListDOM (data) {
  $('#search_filters').replaceWith(data.rendered_facets);
  $('#js-active-search-filters').replaceWith(data.rendered_active_filters);
  $('#js-product-list-top').replaceWith(data.rendered_products_top);
  $('#js-product-list').replaceWith(data.rendered_products);
  $('#js-product-list-bottom').replaceWith(data.rendered_products_bottom);

  let productMinitature = new ProductMinitature();
  productMinitature.init();

  $('.products .product-miniature .product-content').addClass('visible');
}

function bindGrid()
{
  /*var storage = false;
  if (typeof(getStorageAvailable) !== 'undefined') {
    storage = getStorageAvailable();
    console.log('here');
  }
  if (!storage) {
    console.log('there');
    return;
  }*/

  //var view = $.totalStorage('display');
  var view = localStorage.getItem('display');

  if (!view && (typeof displayList != 'undefined') && displayList)
    view = 'grid2';

  if (view && view != 'grid')
    display(view);
  else
    $('.display').find('li#grid').addClass('selected');

  $(document).on('click', '#grid', function(e){
    e.preventDefault();
    display('grid');
  });

  $(document).on('click', '#grid2', function(e){
    e.preventDefault();
    display('grid2');
  });
}

function display(view)
{
  if (view == 'grid2')
  {
    $('body').removeClass('grid').addClass('grid2');
    $('.display').find('li#grid2').addClass('selected');
    $('.display').find('li#grid').removeAttr('class');
    //$.totalStorage('display', 'grid2');
    localStorage.setItem('display', 'grid2');
  }
  else
  {
    $('body').removeClass('grid2').addClass('grid');
    $('.display').find('li#grid').addClass('selected');
    $('.display').find('li#grid2').removeAttr('class');
    //$.totalStorage('display', 'grid');
    localStorage.setItem('display', 'grid');
  }
}
